import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UcpService {
  static readonly token = localStorage.getItem('token');
}
